import {
	CREDIT_FORM_NAMES,
	ERRORS,
} from "../constants";
import Context from "shared/util/Context";

const {
	cardNumber,
	cvv,
	expiration,
	zipCode,
} = CREDIT_FORM_NAMES;

const {
	emptyField,
	malformedZip,
	malformedCvv,
	malformedCardNumber,
	malformedExpiration,
} = ERRORS;

function handleCardNumber(value) {
	if (!/^\d{12,19}$/.test(value.replace(/\s+/g, ""))) {
		return [malformedCardNumber];
	}

	return [];
}

function handleCvv(value) {
	if (!/^\d{3,4}$/.test(value)) {
		return [malformedCvv];
	}

	return [];
}

export function handleZip(value) {
	const country = Context.get("country");

	if (country === "US") {
		if (value.length < 5 || value.length > 5 || /\D/.test(value)) {
			return [malformedZip];
		}
	}

	return [];
}

export function handleExpiration(value) {
	// if there's a slash, allow leading zeros to be drapped
	if (/^(1[0-2]|0?[1-9])\s?\/\s?[12][0-9]$/.test(value)) {
		return [];
	}

	// if there's no slash, requre both digits
	else if (/^(1[0-2]|0[1-9])\s?[12][0-9]$/.test(value)) {
		return [];
	}

	return [malformedExpiration];
}

function handleEmptyValue(value, statusMessages) {
	if (/^s*$/.test(value)) {
		return [
			emptyField,
			...statusMessages,
		];
	}

	return statusMessages;
}

export function validateFormValue({ name, value }) {
	let errors = [];

	switch (name) {
		case cardNumber: {
			errors = handleCardNumber(value);
			break;
		}

		case cvv: {
			errors = handleCvv(value);
			break;
		}

		case expiration: {
			errors = handleExpiration(value);
			break;
		}

		case zipCode: {
			errors = handleZip(value);
			break;
		}

		default:
	}

	return handleEmptyValue(value, errors);
}



// WEBPACK FOOTER //
// ./src/shared/payment/helpers/form-validate.js